import { render, staticRenderFns } from "./SecondAddress.vue?vue&type=template&id=67b9b6f2&scoped=true&"
import script from "./SecondAddress.vue?vue&type=script&lang=js&"
export * from "./SecondAddress.vue?vue&type=script&lang=js&"
import style0 from "./SecondAddress.vue?vue&type=style&index=0&id=67b9b6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b9b6f2",
  null
  
)

export default component.exports